__turbopack_context__.v({
  "badge": "Default-module__lnELcG__badge",
  "inline": "Default-module__lnELcG__inline",
  "leftIcon": "Default-module__lnELcG__leftIcon",
});
